import axios from "axios";
import environment from './environments/index';
import { clearAllStoredConversationCurrentPointers } from './utils/conversationStorage.ts';

const localAuthBaseURL = environment.localApi?.auth ?? environment.localApi?.dashboard;
const primaryAuthBaseURL = environment.api.auth;
const shouldTryLocalAuth = environment.env === "local" && Boolean(localAuthBaseURL);

const instance = axios.create({
  baseURL: shouldTryLocalAuth ? localAuthBaseURL : primaryAuthBaseURL,
});

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error?.config;
    const isNetworkError = !error?.response;
    if (shouldTryLocalAuth && config && !config.__retryWithFallbackAuth && isNetworkError) {
      config.__retryWithFallbackAuth = true;
      config.baseURL = primaryAuthBaseURL;
      return axios(config);
    }
    if (error?.response?.status === 401 && error?.response?.config?.url !== "/oauth/token") {
      const baseURL = window.location.origin;
      localStorage.removeItem("access-RefreshToken-Edify");
      localStorage.removeItem("access-Token-Edify");
      clearAllStoredConversationCurrentPointers();
      window.location.replace(baseURL);
    }
    return Promise.reject(error);
  }
);

export default instance;
